import React from "react";

const {
  getImpersonationHeader,
  shouldDisableAnalytics,
  resetAnalyticsState,
  ImpersonationOverlay,
  isImpersonating,
} = require("@pga/auth-flow-provider").impersonation;

const AuthFlowProvider = require("@pga/auth-flow-provider").auth0
  .AuthFlowProvider;
const { gql } = require("@apollo/client");
const GET_USER_DATA = gql`
  query User {
    me {
      id
      primaryEmail
      type
      firstName
      lastName
      photo
      class
      type
      displayName
      role
    }
  }
`;
const fetchCurrentUser = async (token) => {
  try {
    const res = await window.fetch(process.env.REACT_APP_GRAPHQL_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ...getImpersonationHeader(),
      },
      body: JSON.stringify({ query: GET_USER_DATA.loc.source.body }),
    });

    const json = await res.json();
    const currentUser = json && json.data && json.data.me;
    if (!currentUser) {
      throw new Error("No user found");
    }
    return [currentUser, null];
  } catch (err) {
    return [null, err];
  }
};
const { LoadingComponent } = require("@pga/pga-component-library");
const renderRedirecting = () => <LoadingComponent />;

const AuthProvider = ({ children }) => (
  <AuthFlowProvider
    fetchCurrentUser={fetchCurrentUser}
    renderRedirecting={renderRedirecting}
  >
    {children}
  </AuthFlowProvider>
);

const RedirectToLogin = require("@pga/auth-flow-provider").auth0
  .RedirectToLogin;
const RedirectToLogout = require("@pga/auth-flow-provider").auth0
  .RedirectToLogout;
const redirectToLogout = require("@pga/auth-flow-provider").auth0
  .redirectToLogout;
const withAuthProvider = require("@pga/auth-flow-provider").auth0
  .withAuthProvider;
const getToken = require("@pga/auth-flow-provider").auth0.getToken;

export {
  AuthProvider,
  RedirectToLogin,
  RedirectToLogout,
  redirectToLogout,
  withAuthProvider,
  getToken,
  getImpersonationHeader,
  shouldDisableAnalytics,
  resetAnalyticsState,
  ImpersonationOverlay,
  isImpersonating,
};
